import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4d443088"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column gap-5"
}
const _hoisted_2 = { class: "w-100 bg-white p-5" }
const _hoisted_3 = {
  key: 1,
  class: "d-flex flex-column"
}
const _hoisted_4 = { class: "d-flex justify-content-end mb-5" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1))
const _hoisted_6 = { class: "" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_Chip = _resolveComponent("Chip")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Card = _resolveComponent("Card")!
  const _component_PromoCreateModal = _resolveComponent("PromoCreateModal")!
  const _component_PromoUpdateModal = _resolveComponent("PromoUpdateModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Card, { class: "promo-container" }, {
      title: _withCtx(() => [
        _createTextVNode("Promos")
      ]),
      subtitle: _withCtx(() => [
        _createTextVNode("Found " + _toDisplayString(_ctx.table.total) + " " + _toDisplayString(_ctx.dataText), 1)
      ]),
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_skeleton, {
                  animated: "",
                  row: "5"
                })
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleNew && _ctx.toggleNew(...args))),
                  class: "btn btn-lg btn-primary"
                }, [
                  _hoisted_5,
                  _createTextVNode(" Add Promo ")
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_DataTable, {
                  "table-data": _ctx.table.items,
                  "table-header": _ctx.tableHeaders,
                  "enable-items-per-page-dropdown": true,
                  loading: _ctx.table.loading,
                  "rows-per-page": 10,
                  "row-class": "table-hover",
                  ref: "promoTable",
                  "onClick:row": _ctx.viewDetail
                }, {
                  "cell-status": _withCtx(({ row: item }) => [
                    _createVNode(_component_Chip, {
                      type: _ctx.getStatus(item).type,
                      text: _ctx.getStatus(item).text
                    }, null, 8, ["type", "text"])
                  ]),
                  "cell-name": _withCtx(({ row: item }) => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  "cell-code": _withCtx(({ row: item }) => [
                    _createTextVNode(_toDisplayString(item.code), 1)
                  ]),
                  "cell-amount_off": _withCtx(({ row: item }) => [
                    _createTextVNode(_toDisplayString(item.amount_off), 1)
                  ]),
                  "cell-percent_off": _withCtx(({ row: item }) => [
                    _createTextVNode(_toDisplayString(item.percent_off ? `${item.percent_off}%` : '-'), 1)
                  ]),
                  "cell-action": _withCtx(({ row: item }) => [
                    _createElementVNode("a", {
                      class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                      onClick: _withModifiers(($event: any) => (_ctx.editDetail(item)), ["stop"]),
                      href: "javascript:void(0)"
                    }, _hoisted_9, 8, _hoisted_7),
                    _createElementVNode("a", {
                      class: "btn btn-icon btn-bg-light btn-active-color-danger btn-sm me-1",
                      onClick: _withModifiers(($event: any) => (_ctx.confirmDeletepromo(item)), ["stop"]),
                      href: "javascript:void(0)"
                    }, _hoisted_12, 8, _hoisted_10)
                  ]),
                  _: 1
                }, 8, ["table-data", "table-header", "loading", "onClick:row"])
              ])
            ]))
      ]),
      _: 1
    }),
    _createVNode(_component_PromoCreateModal, {
      modelValue: _ctx.showCreateModal,
      onFormSubmitted: _ctx.handleFormSubimitted,
      onClose: _ctx.handleFormCancelled
    }, null, 8, ["modelValue", "onFormSubmitted", "onClose"]),
    _createVNode(_component_PromoUpdateModal, {
      modelValue: _ctx.showUpdateModal,
      onFormSubmitted: _ctx.handleFormSubimitted,
      onClose: _ctx.handleFormCancelled
    }, null, 8, ["modelValue", "onFormSubmitted", "onClose"])
  ], 64))
}